/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
// eslint-disable-next-line no-unused-vars
import QS from 'qs';
import store from '../store/index';
import router from 'vue-router';
import routerMy from '../router.js'
import notify from 'devextreme/ui/notify';
import daddress from './url'
import { Message,Loading } from 'element-ui';

// 定义 loading
let loading
// loading开始 方法
function startLoading() {
    // element-ui loading 服务调用方式
    loading = Loading.service({
        lock: true,
        text: '拼命加载中...',
        spinner: 'el-icon-loading',  // 自定义图标
        background: 'rgba(0, 0, 0, 0.7)'
    })
}
// loading结束 方法
function endLoading() {
    loading.close()
}

// 环境的切换
if (process.env.NODE_ENV == 'development') {
    axios.defaults.baseURL = daddress.ip;
} else if (process.env.NODE_ENV == 'debug') {
    axios.defaults.baseURL = daddress.ip;
} else if (process.env.NODE_ENV == 'production') {
    axios.defaults.baseURL = daddress.ip;
}

// 请求超时时间
axios.defaults.timeout = 200000;

// post请求头
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 请求拦截器
axios.interceptors.request.use(
    config => {
        // 请求显示loading 效果
        if(config.url!="/api/fun/wxuser/byId"){
            startLoading();
        }
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        const token = localStorage.getItem("token");
        token && (config.headers.token = token);
        return config;
    },
    error => {
        endLoading();
        return Promise.error(error);
    })

// 响应拦截器
axios.interceptors.response.use(
    response => {
        endLoading();
        if(response.data.code==401 || response.data.code==404){
            localStorage.removeItem('token');
            notify({type:'error',message:"登录已失效", position: "top center",width: 1, })
            routerMy.replace('/');
        }

        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是200的情况
    error => {
        endLoading();
        if (error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 401:
                    notify({type:'error',message:"登录已失效", position: "top center",width: 1, })
                    localStorage.removeItem('token');
                    routerMy.replace('/');

                    break;
                // 403 token过期
                // 登录过期对用户进行提示
                // 清除本地token和清空vuex中token对象
                // 跳转登录页面
                case 403:
                    // this.$notify({type:'success',message:'登录过期', position: "top center" });
                    // 清除token
                    localStorage.removeItem('token');
                    store.commit('loginSuccess', null);
                    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
                    setTimeout(() => {
                        router.replace({
                            path: '/login',
                            query: {
                                redirect: router.currentRoute.fullPath
                            }
                        });
                    }, 1000);
                    break;
                // 404请求不存在
                case 404:
                    // Toast({
                    //     message: '网络请求不存在',
                    //     duration: 1500,
                    //     forbidClick: true
                    // });
                    break;
                // 其他错误，直接抛出错误提示
                default:
                    // Toast({
                    //     message: error.response.data.message,
                    //     duration: 1500,
                    //     forbidClick: true
                    // })

            }
            return Promise.reject(error.response);
        }
    }
);
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params){
    return new Promise((resolve, reject) =>{
        axios.get(url, {params: params })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}


//获取验证码
export const getCode = p => get('user/GenerMobileVerificationCode', p);
//注册账号并且创建租户
export const register = p => post('user/register',p)
//注册账号并且加入已经存在的租户
export const joinCompany = p => post('user/joinCompany',p)
//账号密码登录
export const accountLogin = p => post('user/accountLogin',p)
//手机号加验证码登录
export const login = p => post('user/loginOrRegByPhone',p)


//获取菜单
export const getMenu = p => post('role/menu',p)
//获取全部角色
export const getRoleList = p => post('role/list',p)
//添加角色
export const RoleSave = p => post('role/save',p)
//添加角色
export const RoleEdit = p => post('role/edit',p)
//根据id查询角色和权限
export const RoleById = p => get('role/byId', p);


//查询当前租户有权限管理的用户
export const getUserList = p => post('user/list',p)
//禁用启用用户
export const openOrClose = p => post('user/openOrClose',p)
//管理员添加账号
export const getUserAdd = p => post('user/add',p)
//管理员修改账号
export const getUserEdit = p => post('user/edit',p)
//根据id查询
export const getUserById = p => get('user/byId',p)
// 查询用户点数
export const getUserPoint = p => get('user/getPoint',p)
// 修改密码
export const updatePassword = p => post('user/updatePassword',p)
// 获取绑定的手机号
export const getBindPhone = p => post('user/getBindPhone',p)


//查询用户推送记录
export const getUserRecord = (data) => get('api/fun/wxuser/getUserRecord',data);
//根据id查询AppId
export const getAppId = (data) => get('wechat/getAppId',data);

export const get_marketing_list = (data) => get('wx_public/marketing_model', data);
export const get_wxconfig = (data) => get('wechat/get_wxconfig', data);
export const get_template_all = (data) => get('api/send/get_all_private_template', data);
export const get_all_tags_pu = (data) => get('api/tags/get_all_tags_pu', data);
export const get_allTags = (data) => get('api/tags/get_allTags', data);
export const get_qrcode = (data) => get('api/send/getQrcode',data);
export const get_model_info = (data) => get('wx_public/get_model_info',data);
export const get_marketing_history = (data) => get('api/message/message_marketing_list',data);
export const get_message_user = (data) => get('api/fun/wxuser/message_user',data);



export const add_marketing_model = (data) => post('wx_public/add_model_marketing', data);
export const modify_marketing_model = (data) => post('wx_public/modify_marketing', data);
export const del_marketing_model = (data) => post('wx_public/del_marketing', data);
export const send_message_public = (data) => post("api/send/send_message_public",data);
export const send_activity_message = (data) => post("wechat/send_activity_message",data);
export const add_wx_cofig = (data) => post("wechat/add_wxconfig",data);
export const modify_wx_cofig = (data) => post("wechat/modify_Wxcofig",data);

// export const upload_img = (data) => post("wx_public/upload_img",data);
// eslint-disable-next-line no-undef
export const upload_file = (data) => upload("wx_public/upload_img",data);
//查询全部客户
export const CustomerList = p => post('/api/fun/wxuser/list', p);
//线索核验
export const CustomerCheck = p => post('/api/fun/wxuser/check', p);
//批量删除客户
export const CustomerDel = p => post('/api/fun/wxuser/del', p);
//添加客户(公众号)
export const CustomerAdd = p => post('/api/fun/wxuser/add', p);
//添加客户(内部)
export const CustomerSave = p => post('/api/fun/wxuser/save', p);

//修改客户
export const CustomerEdit = p => post('/api/fun/wxuser/edit', p);
//根据id查询客户
export const CustomerById = p => get('/api/fun/wxuser/byId', p);

export const ClueFindAll = p => post('clue/findAll', p);
export const ClueAdd = p => post('clue/add', p);
export const ClueDel = p => post('clue/del', p);
export const ClueEdit = p => post('clue/edit', p);
export const ClueFindOneById = p => get('clue/findOneById', p);

//查询全部内容
export const ContentList = p => post('content/list', p);
//添加内容
export const ContentAdd = p => post('content/add', p);
//修改推送日期
export const ContentSort = (data) => post('content/sort', data);
//查询全部标签
export const LabelList = p => post('label/list', p);
//添加标签
export const LabelAdd = p => post('label/add', p);
//修改标签
export const LabelEdit = p => post('label/edit', p);
//删除标签
export const LabelRemove = p => post('label/remove', p);
//标签统计总数
export const LabelStatistics = p => post('label/statistics', p);
//用户设置标签
export const setLabel = p => post('label/setLabel', p);


//调用支付接口
export const wxPay = p => post('wxPay/prepayment', p);
//刷新点数
export const renewPoints = p => post('user/renewPoints', p);
//获取用户后台任务
export const TaskList = p => post('userTask/list', p);
//
export const getWxUserOne = p => post('api/fun/wxuser/getWxUserOne', p);

export const getIp = p => get('api/fun/wxuser/getIp', p);
//高级搜索手机号码
export const PhonePage = p => post('phone/page', p);
//根据id获取手机号
export const GetPhone = p => post('phone/getPhone', p);


//查询全部客户
export const getUserDetails = p => get('/api/fun/wxuser/getUserDetails', p);


//查询群发内容
export const getMessageAllList= p => post('api/message/list', p);
export const messageAllAdd= p => post('api/message/add', p);
export const messageAllSend= p => get('api/message/messageAllSend', p);


//查询文件名
export const getAllFileName = p => post('check/getAllFileName', p);
export const delFile = p => post('check/delFile', p);

//查询个体户
export const searchGTH = p => post('gth/search', p);
export const countSearchGTH = p => post('gth/countSearch', p);
export const exportDataGTH = p => post('gth/exportData', p);
export const viewLpPhoneGTH = p => post('gth/viewLpPhone', p);


export const searchClue = p => post('clue/search', p);
export const countSearchClue = p => post('clue/countSearch', p);
export const exportDataClue = p => post('clue/exportData', p);
export const viewLpPhoneClue = p => post('clue/viewLpPhone', p);

export const getPointMealAllList = p => get('meal/listAll', p);

export const searchTaxpayer = p => post('taxpayer/search', p);
export const countSearchTaxpayer = p => post('taxpayer/countSearch', p);
export const exportDataTaxpayer = p => post('taxpayer/exportData', p);
export const viewLpPhoneTaxpayer = p => post('taxpayer/viewLpPhone', p);
// 明细流水
export const viewConsumeBill = p => post('accountBill/user/search', p);
export const countPurchase = p => post('accountBill/countPurchase', p);
export const getPointCountView = p => post('user/getPointCountView', p);

export const searchSelfEmployeeCode = p => post('selfEmployeeCode/search', p);
export const countSearchSelfEmployeeCode = p => post('selfEmployeeCode/countSearch', p);
export const exportDataSelfEmployeeCode = p => post('selfEmployeeCode/exportData', p);
export const viewLpPhoneSelfEmployeeCode = p => post('selfEmployeeCode/viewLpPhone', p);

export const searchTeXinQiYe = p => post('teXinQiYe/search', p);
export const countSearchTeXinQiYe = p => post('teXinQiYe/countSearch', p);
export const exportDataTeXinQiYe = p => post('teXinQiYe/exportData', p);
export const viewLpPhoneTeXinQiYe = p => post('teXinQiYe/viewLpPhone', p);
